<template>
	<div>
		<route-plan-inner :updating="false" @update="saveRoute" />
		<confirm ref="confirm"></confirm>
	</div>
</template>

<script>
import RoutePlanInner from '@/components/routeplan/routeplan-inner';
import RoutePlanService from '@/api-services/routeplan.service';
import Confirm from '@/components/partials/confirm';

export default {
	name: 'RoutePlanCreate',

	components: {
		RoutePlanInner,
		Confirm
	},

	data() {
		return {
			RoutePlanService: RoutePlanService
		};
	},

	methods: {
		saveRoute(_routeDTO) {
			RoutePlanService.create(_routeDTO)
				.then((res) => {
					let modal_options = {
						text: 'light',
						background: 'success'
					};
					
					this.$refs.confirm.open('Success', 'Go back to route plans list?', false, modal_options).then((confirm) => {
						if (confirm) {
							this.$router.push({
								name: 'routeplans'
							});
						} else {
							this.$router.push({
								name: 'routeplanupdate',
								params: { id: res.data.Id }
							});
						}
					});
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = !err.MessageDetail == null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-create.vue